import Vuex from 'vuex'
import {defaultModule} from '../../../modules/defaultModule'
import {alertModule} from "../../../modules/alertModule";
import {confirmModule} from "../../../modules/confirmModule";
import {screenModule} from "../../../modules/screenModule";
import Vue from "vue";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        default: defaultModule,
        alert: alertModule,
        confirm: confirmModule,
        screen: screenModule
    }
});
